import axios from "axios"
import { ticketBaseURL } from "../configs/api";

export const put_Address = (data: any, userId: number) => {
    return axios({
        url: `${ticketBaseURL}rdRentalAddress?userId=${userId}`,
        method: "PUT",
        headers: {          
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getRdRentalAddressByTenantId = (tenantId: string) => {
    return getFetch(`rdRentalAddress/GetRdRentalAddressByTenantId/${tenantId}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        headers: {          
            'Content-Type': 'application/json'
        },
        params: params
    }).then(response => response.data);
}